import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { EditorState } from 'draft-js';
import handleKeyPress from '../../../../../../../../common/handleKeyPress';
import BananatagButton from '../../../../../../../../componentLibrary/BananatagButton';
import ColorPicker from '../../../../../../../../componentLibrary/ColorPicker/ColorPicker';
import ColorPickerIcon from '../../../../../../../../componentLibrary/ColorPickerIcon';
import HighlighterIcon from '../../../../../../../../componentLibrary/HighlighterIcon';
import { TAppState } from '../../../../../../../../reducers';

interface IProps {
    config: {
        popupClassName: {
            editorState: EditorState;
            applyChanges: (editorState: EditorState) => void;
        };
    };
    onChange: (type: string, hex: string) => void;
    currentState: {
        color: string;
        bgColor: string;
    };
    session: any;
}

class ColorPic extends Component<IProps> {
    state = {
        displayBgColorPicker: false,
        displayColorPicker: false,
        colorChanged: false,
        bgcolorChanged: false,
    };

    render() {
        const {
            onChange,
            currentState,
            config,
            session: {
                user,
                integration,
                features: { F_COLOR_PALETTE },
            },
        } = this.props;
        const {
            customization: { colors },
        } = user;
        const { features, isAdminOrParentAdmin } = user;
        const { editorState, applyChanges } = config.popupClassName;
        const { color, bgColor } = currentState;
        const { displayBgColorPicker, displayColorPicker, colorChanged, bgcolorChanged } = this.state;
        const brandColors = JSON.parse(colors).filter((item: any) =>
            Object.prototype.hasOwnProperty.call(item, 'color')
        );
        const hasFullStylingAccess =
            features.EMAIL_DESIGNER_STYLING_ACCESS === undefined ? true : features.EMAIL_DESIGNER_STYLING_ACCESS;
        const hasCustomizationFeature = features.EMAIL_DESIGNER_CUSTOMIZATION;
        const hasCustomizationAccess = isAdminOrParentAdmin && (integration === 'LOCALHOST' || integration === 'APP');

        return (
            <>
                <div
                    aria-haspopup="true"
                    aria-expanded={displayColorPicker}
                    aria-label="rdw-color-picker"
                    className="draftButton borderLeft borderRight"
                    data-test-id="color-picker-open-icon-button"
                    style={{
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        width: 78,
                        paddingLeft: 3,
                        height: 28,
                    }}
                >
                    <div
                        onClick={() => {
                            this.setState({ displayColorPicker: !displayColorPicker, displayBgColorPicker: false });
                        }}
                        onKeyDown={(e) =>
                            handleKeyPress(e, () => {
                                this.setState({ displayColorPicker: !displayColorPicker, displayBgColorPicker: false });
                            })
                        }
                        style={{
                            height: 20,
                            lineHeight: '20px',
                            border: '1px solid rgb(175, 175, 175)',
                            cursor: 'pointer',
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        <div data-tip data-for="textColorPicker" style={{ width: 20, height: 20 }}>
                            <ColorPickerIcon fill={color || '#000000'} />
                        </div>
                        <ReactTooltip id="textColorPicker" place="top" effect="solid">
                            <span style={{ fontWeight: 'bold' }}>Text Color</span>
                        </ReactTooltip>
                    </div>
                    <div
                        data-tip
                        data-for="textHighlighter"
                        onClick={() => {
                            this.setState({ displayBgColorPicker: !displayBgColorPicker, displayColorPicker: false });
                        }}
                        onKeyDown={(e) =>
                            handleKeyPress(e, () => {
                                this.setState({
                                    displayBgColorPicker: !displayBgColorPicker,
                                    displayColorPicker: false,
                                });
                            })
                        }
                        style={{ height: 20, lineHeight: '20px', cursor: 'pointer' }}
                        role="button"
                        tabIndex={0}
                    >
                        <HighlighterIcon fill={bgColor} />
                        <ReactTooltip id="textHighlighter" place="top" effect="solid">
                            <span style={{ fontWeight: 'bold' }}>Highlight Color</span>
                        </ReactTooltip>
                    </div>
                </div>
                {displayColorPicker &&
                    (!hasFullStylingAccess ? (
                        <div style={{ position: 'absolute', top: 39, left: 102 }}>
                            {/* @ts-ignore */}
                            <ColorPicker
                                color={color}
                                presetColors={brandColors}
                                onChangeComplete={(pickedColor) => {
                                    onChange('color', pickedColor.hex);
                                }}
                            />
                        </div>
                    ) : (
                        <div style={{ position: 'absolute', top: 34, left: 104 }}>
                            {/* @ts-ignore */}
                            <ColorPicker
                                hasFullStylingAccess={hasFullStylingAccess}
                                hasCustomizationFeature={hasCustomizationFeature}
                                hasCustomizationAccess={hasCustomizationAccess}
                                disableAlpha
                                color={color}
                                presetColors={brandColors}
                                onChangeComplete={(pickedColor) => {
                                    onChange('color', pickedColor.hex);
                                    this.setState({ colorChanged: true });
                                }}
                            />
                            <div
                                style={{
                                    width: '100%',
                                    backgroundColor: 'white',
                                    position: hasCustomizationFeature || !F_COLOR_PALETTE ? 'absolute' : 'static',
                                    borderRadius: '0 0 4px 4px',
                                    border: '1px solid lightgray',
                                    borderTop: 'none',
                                    padding: '2px 0',
                                    marginTop: '-3px',
                                    marginLeft: '-1px',
                                }}
                            >
                                <BananatagButton
                                    text="Apply"
                                    onClick={() => {
                                        applyChanges(editorState);
                                        this.setState({ displayColorPicker: false });
                                    }}
                                    type="solid"
                                    size="small"
                                    styling={{ margin: 4, padding: '0 84px' }}
                                    disabled={!colorChanged}
                                />
                            </div>
                        </div>
                    ))}
                {displayBgColorPicker &&
                    (!hasFullStylingAccess ? (
                        <div style={{ position: 'absolute', top: 39, left: 150 }}>
                            {/* @ts-ignore */}
                            <ColorPicker
                                color={bgColor}
                                presetColors={brandColors}
                                onChangeComplete={(pickedColor) => {
                                    onChange('bgcolor', pickedColor.hex);
                                    this.setState({ bgcolorChanged: true });
                                }}
                            />
                        </div>
                    ) : (
                        <div style={{ position: 'absolute', top: 34, left: 152 }}>
                            {/* @ts-ignore */}
                            <ColorPicker
                                hasFullStylingAccess
                                hasCustomizationFeature={hasCustomizationFeature}
                                hasCustomizationAccess={hasCustomizationAccess}
                                disableAlpha
                                color={bgColor}
                                presetColors={brandColors}
                                onChangeComplete={(pickedColor) => {
                                    onChange('bgcolor', pickedColor.hex);
                                    this.setState({ bgcolorChanged: true });
                                }}
                            />
                            <div
                                style={{
                                    width: '100%',
                                    backgroundColor: 'white',
                                    position: hasCustomizationFeature || !F_COLOR_PALETTE ? 'absolute' : 'static',
                                    borderRadius: '0 0 4px 4px',
                                    border: '1px solid lightgray',
                                    borderTop: 'none',
                                    padding: '2px 0',
                                    marginTop: '-3px',
                                    marginLeft: '-1px',
                                }}
                            >
                                <BananatagButton
                                    text="Apply"
                                    onClick={() => {
                                        applyChanges(editorState);
                                        this.setState({ displayColorPicker: false });
                                    }}
                                    type="solid"
                                    size="small"
                                    styling={{ margin: 4, padding: '0 84px' }}
                                    disabled={!bgcolorChanged}
                                />
                            </div>
                        </div>
                    ))}
            </>
        );
    }
}

const mapStateToProps = (state: TAppState) => ({
    session: state.session,
});

export default connect(mapStateToProps)(ColorPic);
